export const agentsHistoryNames = {
	PAYEE_NAME: "payment_info.payee_name",
	BUSINESS_UNIT: "payment_info.business_unit",
	BUSINESS_UNIT_HIERARCHY: "payment_info.business_unit_hierarchy",
	TYPE: "payment_info.type",
	INTERNATIONAL_WIRE_IBAN: "payment_info.international_wire.iban",
	INTERNATIONAL_WIRE_SWIFT_BIC: "payment_info.international_wire.swift_bic",
	DOMESTIC_ABA: "payment_info.domestic_wire.aba",
	DOMESTIC_DBA: "payment_info.domestic_wire.dba",
	ACH_ABA: "payment_info.ach.aba",
	ACH_DBA: "payment_info.ach.dba",
	ACH_ACCOUNT_TYPE: "payment_info.ach.account_type",
	DOMESTIC_WIRE_ACCOUNT_TYPE: "payment_info.domestic_wire.account_type",
	CHECK_POSTAL_CODE: "payment_info.check.address.postal_code",
	CHECK_ADDRESS: "payment_info.check.address.address",
	CHECK_CITY: "payment_info.check.address.city",
	CHECK_STATE: "payment_info.check.address.state",
	IS_DELETED: "payment_info.is_deleted",
};

export function getAgentHistoryTitleName(fieldName) {
	let name = "";

	if (fieldName === agentsHistoryNames.PAYEE_NAME) name = "Payee Name";
	else if (fieldName === agentsHistoryNames.BUSINESS_UNIT)
		name = "Business Unit";
	else if (fieldName === agentsHistoryNames.BUSINESS_UNIT_HIERARCHY)
		name = "Business Unit Hierarchy";
	else if (fieldName === agentsHistoryNames.TYPE) name = "Payout Method Type";
	else if (fieldName === agentsHistoryNames.INTERNATIONAL_WIRE_IBAN)
		name = "International Wire IBAN Account Number";
	else if (fieldName === agentsHistoryNames.INTERNATIONAL_WIRE_SWIFT_BIC)
		name = "International Wire SWift BIC";
	else if (fieldName === agentsHistoryNames.ACH_ABA)
		name = "ACH Routing Number (ABA)";
	else if (fieldName === agentsHistoryNames.ACH_DBA)
		name = "ACH Account Number (DDA)";
	else if (fieldName === agentsHistoryNames.ACH_ACCOUNT_TYPE)
		name = "ACH Account Type";
	else if (fieldName === agentsHistoryNames.DOMESTIC_ABA)
		name = "Domestic Wire Routing Number (ABA)";
	else if (fieldName === agentsHistoryNames.DOMESTIC_DBA)
		name = "Domestic Wire Routing Number (DDA)";
	else if (fieldName === agentsHistoryNames.DOMESTIC_WIRE_ACCOUNT_TYPE)
		name = "Domestic Wire Account Type";
	else if (fieldName === agentsHistoryNames.CHECK_ADDRESS)
		name = "Check House Number & Street";
	else if (fieldName === agentsHistoryNames.CHECK_CITY) name = "Check City";
	else if (fieldName === agentsHistoryNames.CHECK_STATE) name = "Check State";
	else if (fieldName === agentsHistoryNames.CHECK_POSTAL_CODE)
		name = "Check Zip Code";
	else if (fieldName === agentsHistoryNames.IS_DELETED)
		name = "Pay Residuals to Agent Office";
	else return;

	return name;
}
export const mainHistoryScheduleANames = {
	NAME: "name",
	PARENT_ID: "parent_id",
	PROCESSOR_ID: "processor_id",
	STATUS: "status",
	ARE_FEES_NOT_APPLICABLE: "are_fees_not_applicable",
	SCHEDULE_A: "schedule_a",
};

export function getScheduleAFeeLabel(type) {
	let label = "";
	switch (type) {
		case "bin_sponsorship_fee":
			label = "BIN Sponsorship Fee";
			break;
		case "amex_opt_blue_fee":
			label = "Amex Opt Blue Fee";
			break;
		case "interchange_fee":
			label = "Interchange Fee";
			break;
		case "cardbrand_dues_and_assessments_fee":
			label = "Cardbrand Dues & Assessments Fee";
			break;
		case "debit_switch_fee":
			label = "Debit Switch Fee";
			break;
		case "debit_network_fee":
			label = "Debit Network Fee";
			break;
		case "dial_authorization_fee":
			label = "Dial Authorization Fee";
			break;
		case "cpu_authorization_fee":
			label = "CPU Authorization Fee";
			break;
		case "ip_authorization_fee":
			label = "IP Authorization Fee";
			break;
		case "sales_transaction_fee":
			label = "Sales Transaction Fee";
			break;
		case "voice_authorization_fee":
			label = "Voice Authorization Fee";
			break;
		case "avs_fee":
			label = "AVS Fee";
			break;
		case "batch_header_fee":
			label = "Batch Header Fee";
			break;
		case "chargeback_fee":
			label = "Chargeback Fee";
			break;
		case "retrieval_12b_letter_fee":
			label = "Retrieval (12B Letter) Fee";
			break;
		case "statement_fee":
			label = "Statement Fee";
			break;
		case "portfolio_manager_or_access_one_fee":
			label = "Portfolio Manager / Access One Fee";
			break;
		case "pci_monthly_fee":
			label = "PCI Monthly Fee";
			break;

		case "pci_non_validation_fee":
			label = "PCI Non-Validation Fee";
			break;
		case "regulatory_product_fee":
			label = "Regulatory Product Fee";
			break;
		case "transarmor_data_protection_only_for_clover_flat_fee":
			label = "Transarmor Data Protection Only For Clover Flat Fee";
			break;
		case "annual_fee":
			label = "Annual Fee";
			break;
		case "tin_invalid_fee":
			label = "TIN Invalid Fee";
			break;
		case "wireless_monthly_service_fee":
			label = "Wireless Monthly Service Fee";
			break;
		case "wireless_setup_and_activation_fee":
			label = "Wireless Set up & Activation Fee";
			break;
		case "account_on_file_fee":
			label = "Account on File Fee";
			break;
		case "aru_fee":
			label = "ARU Fee";
			break;
		case "wex_discount_fee":
			label = "Wex Discount Fee";
			break;
		case "wex_per_item_fee":
			label = "WEX Per-item Fee";
			break;
		case "voyager_rate_fee":
			label = "Voyager Rate Fee";
			break;
		case "voyager_per_item_fee":
			label = "Voyager Per-item Fee";
			break;
		case "postage_fee":
			label = "Postage Fee";
			break;
		case "clover_security_plus_flat_fee":
			label = "Clover Security Plus Flat Fee";
			break;
		case "tsys_guardian_or_tokenization_authorization_fee":
			label = "TSYS Guardian/ Tokenization Authorization Fee";
			break;
		case "micros_authorization_surcharge_fee":
			label = "Micros Authorization Surcharge Fee";
			break;
		case "clover_transarmor_data_protection_flat_fee":
			label = "Clover Transarmor Data Protection Flat Fee";
			break;
		case "payeezy_avs_fee":
			label = "Payeezy AVS Fee";
			break;
		case "early_termination_fee":
			label = "Early Termination Fee";
			break;
		case "after_hour_help_desk_fee":
			label = "After Hour Help Desk Fee";
			break;
		case "rise_free_programme_with_warranty_fee":
			label = "Rise Free Programme w/ Warranty Fee";
			break;
		case "payeezy_capture_fee":
			label = "Payeezy Capture Fee";
			break;
		case "micros_capture_fee":
			label = "Micros Capture Fee";
			break;
		case "clover_services_fee":
			label = "Clover Services Fee";
			break;
		case "clover_go_fee":
			label = "Clover Go Fee";
			break;
		case "payeezy_one_time_setup_fee":
			label = "Payeezy One Time Set Up Fee";
			break;
		case "tsys_guardian_or_tokenization_monthly_fee":
			label = "TSYS Guardian/ Tokenization Monthly Fee";
			break;
		case "payeezy_monthly_fee":
			label = "Payeezy Monthly Fee";
			break;
		case "eids_dispute_tool_fee":
			label = "eIDS Dispute Tool Fee";
			break;
		case "payeezy_authorization_fee":
			label = "Payeezy Authorization Fee";
			break;
		case "rise_free_programme_fee":
			label = "Rise Free Programme Fee";
			break;
		case "clover_and_data_protection_service_fee":
			label = "Clover & Data Protection Service Fee";
			break;
		case "buypass_pre_auth_completion_fee":
			label = "Buypass Pre-Auth Completion Fee";
			break;
		case "user_6_rev":
			label = "User 6 Rev";
			break;
		case "user_3_rev":
			label = "User 3 Rev";
			break;
		case "user_5_rev":
			label = "User 5 Rev";
			break;
		case "user_1_rev":
			label = "User 1 Rev";
			break;
		case "user_2_rev":
			label = "User 2 Rev";
			break;
		case "user_4_rev":
			label = "User 4 Rev";
			break;
		case "marketing_fee":
			label = "Marketing Fee";
			break;
		case "aurora_pos_fee":
			label = "Aurora POS Fee";
			break;
		case "platform_fee":
			label = "Platform Fee";
			break;
		default:
			break;
	}
	return label;
}

export function getFeeFieldName(fieldName) {
	let label = "";
	switch (fieldName) {
		case "rate":
			label = "Rate";
			break;
		case "revenue_share":
			label = "Revenue Share";
			break;
		case "per_item_fee":
			label = "Per Item Fee";
			break;
		case "pricing_method":
			label = "Pricing Method";
			break;
		default:
			break;
	}
	return label;
}

export const historySplitProfilesNames = {
	SPLIT_PROFILE: "split_profile",
	NAME: "name",
	SCENARIO: "scenario",
	IS_AVAILABLE: "is_available",
	IS_HIGH_RISK: "is_high_risk",
	SPLIT_PERCENT: "split_percent",
	TOTAL_REVENUE_SHARE: "total_revenue_share",
	SECONDARY_SPLIT_INFORMATION: "secondary_split_information",
	SCHEDULE_A_ID: "schedule_a_id",
	IS_PRIVATE: "is_private",
};

export const paymentMethodTypes = {
	NONE: "none",
	ACH: "ach",
	DOMESTIC_WIRE: "domestic_wire",
	INTERNATIONAL_WIRE: "international_wire",
	CHECK: "check",
	PAYROLL: "payroll",
};

export function getPaymentMethodTypes(fieldName) {
	let label = "";
	switch (fieldName) {
		case paymentMethodTypes.NONE:
			label = "None";
			break;
		case paymentMethodTypes.ACH:
			label = "ACH";
			break;
		case paymentMethodTypes.DOMESTIC_WIRE:
			label = "Domestic Wire";
			break;
		case paymentMethodTypes.INTERNATIONAL_WIRE:
			label = "International Wire";
			break;
		case paymentMethodTypes.CHECK:
			label = "Check";
			break;
		case paymentMethodTypes.PAYROLL:
			label = "Payroll";
			break;
		default:
			break;
	}
	return label;
}
